import React, { Component } from "react"
import FocusLock from "react-focus-lock"

import { ProtocolOverview } from "./components/modals/protocolOverview"
import { ProtocolTable } from "./components/modals/protocolTable"

import { PipetteVolume } from "./components/modals/pipetteVolume"
// import { ThermocyclerControls } from "./components/modals/thermocyclerControls"
import { ThermocyclerPoster } from "./components/modals/thermocyclerPoster"
import { PowerSupplyControls } from "./components/modals/PowerSupplyControls"
import { GelPosition } from "./components/modals/GelPosition"
import { GelPipette } from "./components/modals/GelPipette"
// import { WaterBathControls } from "./components/modals/waterBathControls"
//import { TransilluminatorControls } from "./components/modals/TransilluminatorControls"
import { LabelTubes } from "./components/modals/LabelTubes"
import { AnimationSequence } from "./components/modals/animationSequence"

// Animation dialogs

import { DepositSolution } from "./components/modals/depositSolution"
import { LoadGelBoxSolution } from "./components/modals/loadGelBoxSolution"
import { PrepareGelBox } from "./components/modals/prepareGelBox"
import { RunGelBox } from "./components/modals/runGelBox"
import { VisualiseGel } from "./components/modals/visualiseGel"

// import MicroCentrifugeBalancer from "components/modal/modals/microCentrifugeBalancer/MicroCentrifugeBalancer"
// import MicroCentrifugeControls from "components/modal/modals/microCentrifugeControls/microCentrifugeControls"
// import PowerSupplyControls from "components/modal/modals/powerSupplyControls/PowerSupplyControls"
// import GelPosition from "components/modal/modals/gelPosition/GelPosition"
import { Undo } from "./components/modals/undo"

import close from "./img/close.svg"
import "./style.scss";
import { QuestionTable } from "./components/modals/questionTable/QuestionTable"

export class Modal extends Component {

  getContent = type => {
    switch (type) {
      case "PROTOCOL_READ":
        return <ProtocolOverview />;

      case "PROTOCOL_TABLE":
        return <ProtocolTable />;

      case "THERMOCYCLER_POSTER":
        return <ThermocyclerPoster />;

      case "POWERSUPPLY_CONTROLS":
        return <PowerSupplyControls id={this.props.connect} />;

      // case "TRANSILLUMINATOR_CONTROLS":
      //   return <TransilluminatorControls id={this.props.connect} />;

      case "PIPETTE_VOLUME":
        return <PipetteVolume id={this.props.connect} />;

      // case "THERMOCYCLER_CONTROLS":
      //   return <ThermocyclerControls id={this.props.connect} />;

      case "DEPOSIT_SOLUTION":
        return <DepositSolution />;

      case "LOAD_GELBOX_SOLUTION":
        return <LoadGelBoxSolution />;

      case "PREPARE_GELBOX":
        return <PrepareGelBox />;

      case "RUN_GELBOX":
        return <RunGelBox />;

      case "VISUALISE_GEL":
        return <VisualiseGel />;

      case "GEL_POSITION":
        return <GelPosition id={this.props.connect}/>;

      case "QUESTION_TABLE_FILL_IN":
        return <QuestionTable />;

      case "GEL_PIPETTE":
        return (
          <GelPipette
            pipetteId={this.props.pipetteId}
            gelId={this.props.gelId}
            gelBoxId={this.props.gelBoxId}
          />
        );
      // case "WATER_BATH_CONTROLS":
      //   return <WaterBathControls id={this.props.waterBathId} />;

      case "LABEL_TUBES":
        return <LabelTubes id={this.props.connect} />;

      case "PIPETTE_PLUNGER":
        return <AnimationSequence
                  id={this.props.connect}
                  animation={this.props.data.animation}
                  type={type}
               />;
      case "PUT_ON_PPE":
        console.log('running PUT_ON_PPE');
        return <AnimationSequence
                id={this.props.connect}
                animation={this.props.data.animation}
                type={type}
              />;
      // case "MICROCENTRIFUGE_BALANCER":
      //   return <MicroCentrifugeBalancer id={this.props.connect} />;
      //
      // case "MICROCENTRIFUGE_CONTROLS":
      //   return <MicroCentrifugeControls id={this.props.connect} />;
      //
      // case "POWERSUPPLY_CONTROLS":
      //   return <PowerSupplyControls id={this.props.connect} />;

      //
      case "UNDO":
        return <Undo />

      default:
        return "No modal type matched";
    }
  };

  close = () => {
    this.props.showModal({ display: false });
  };

  applyFocusLock = (innerJSX) => {
    if(this.props.noteEntryOpen || ["Predictions","Results","Reflection"].includes(this.props.sectionSelected) ){
      //No focus lock if: notesEntry is open OR predictions, results, or reflection is open
      return innerJSX
    } else {
      return (
        <FocusLock>
          {innerJSX}
        </FocusLock>
      )
    }
  }

  render() {
    //passes inner into above func, wraps in focus lock if needed
    let inner = (
        <div
          className={"ProtocolModal " + this.props.size}
          style={{ display: this.props.display ? "flex" : "none" }}
        >
          <div
            style={{
              display: "block"
            }}
          >
            <div className="wrapper">
              <div
                aria-label="Close Button"
                tabIndex={0}
                className={
                  this.props.type === "UNDO" &&
                  this.props.size === "sm"
                    ? "close-sm"
                    : "close"
                }

                onKeyDown={e => {
                  if (e.keyCode === 13 || e.keyCode === 32) this.close(e);
                }}
                onClick={this.close}
              >
                <p>
                  Close{" "}
                  <img
                    style={{
                      display: "inline-block",
                      top: "3px",
                      position: "relative"
                    }}
                    src={close}
                    aria-label="Close button"
                    alt="Close button"
                  />
                </p>
              </div>
              {this.getContent(this.props.type)}
            </div>
          </div>
        </div>
    );

    return (this.applyFocusLock(inner))
  }
}
